import {Button, ListItemText, MenuItem, MenuList} from '@mui/material';
import {CaretDown} from '@phosphor-icons/react';
import {selectForecastMapBuilderEnabled} from '@smartmixin/core';
import {messages} from '@smartmixin/i18n';
import React from 'react';
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';
import Menu from '../../../components/Menu';
import RouterLink from '../../../lib/RouterLink';

/**
 * Top-nav "Cartes de prévision" dropdown. The whole menu is gated on
 * `forecast_maps` by the parent (AppNavBar); the "Builder" entry is
 * additionally gated on `forecast_map_builder`, fail-closed — matching the
 * composer entry points, which are the only other way to reach the builder.
 */
const ForecastMapsMenu = () => {
  const {formatMessage} = useIntl();
  const builderEnabled = useSelector(selectForecastMapBuilderEnabled);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const openMenu = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const closeMenu = React.useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <Button
        color="inherit"
        size="small"
        aria-controls="forecast-maps-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={openMenu}
        endIcon={<CaretDown size={14} />}
        data-testid="forecast-maps-menu-button">
        {formatMessage(messages.forecastMaps.title)}
      </Button>
      <Menu
        id="forecast-maps-menu"
        anchorEl={anchorEl}
        open={open}
        onClick={closeMenu}
        onClose={closeMenu}>
        <MenuList disablePadding>
          <MenuItem
            component={RouterLink}
            to="/forecast-maps"
            data-testid="forecast-maps-menu-interactive">
            <ListItemText primary={formatMessage(messages.forecastMaps.mapView)} />
          </MenuItem>
          <MenuItem
            component={RouterLink}
            to="/forecast-maps/zones"
            data-testid="forecast-maps-menu-zones">
            <ListItemText primary={formatMessage(messages.forecastMaps.byZone)} />
          </MenuItem>
          <MenuItem
            component={RouterLink}
            to="/forecast-maps/models"
            data-testid="forecast-maps-menu-models">
            <ListItemText primary={formatMessage(messages.forecastMaps.byModel)} />
          </MenuItem>
          {builderEnabled && (
            <MenuItem
              component={RouterLink}
              to="/forecast-maps/builder"
              data-testid="forecast-maps-menu-builder">
              <ListItemText
                primary={formatMessage(messages.forecastMaps.builderTitle)}
              />
            </MenuItem>
          )}
        </MenuList>
      </Menu>
    </>
  );
};

export default ForecastMapsMenu;
